import * as React from 'react';
import ChatClient from 'fk-cp-chat';
import cx from 'classnames';
import FluidCarousel from 'components/FluidCarousel/FluidCarouselVariableWidth';
import styles from './QuickReplies.css';
export class QuickReplies extends React.Component {
    constructor(props) {
        super(props);
        this.handleQuickReplySelect = message => () => {
            this.chatClient.sendMessage(this.props.selectedChat, message);
            this.props.messageSendCallback();
        };
        this.chatClient = ChatClient.getInstance();
    }
    render() {
        const { data } = this.props;
        let decodedMessage;
        let messageContent;
        let show = true;
        try {
            decodedMessage = JSON.parse(data.decodedMessageBody);
            messageContent = decodedMessage.contents;
        }
        catch (error) {
            show = false;
        }
        return (<div className={cx(styles['quick-replies-wrapper'], {
            [styles['show']]: show
        })}>
				{show && (<div className={styles['quick-replies']}>
						<FluidCarousel smallerButtons firstItemClass={styles['first-item']} lastItemClass={styles['last-item']}>
							{messageContent.map((item, index) => (<div className={styles['quick-reply-wrapper']} key={index} onClick={this.handleQuickReplySelect(item)}>
									<div className={styles['quick-reply']}>{item}</div>
								</div>))}
						</FluidCarousel>
					</div>)}
			</div>);
    }
}
export default QuickReplies;
